<mat-toolbar mat-dialog-title class="mat-accent m-0">
  <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
    <span class="title dialog-title">Change Password</span>
    <button (click)="onNoClick()" aria-label="Close dialog">
      <mat-icon class="closebtn">close</mat-icon>
    </button>
  </div>
</mat-toolbar>

<div style="padding: 20px 0px;">
  <div fxFlex fxLayout="row" fxLayoutAlign="center center">
    <form name="changePasswordForm" [formGroup]="changePasswordForm" novalidate style="width: 85%;">
      <div>
        <div fxLayout="column" fxLayoutAlign="center" fxLayout.sm="column" fxLayout.xs="column">
          <div fxFlex>
            <mat-form-field class="example-full-width" style="width: 100%">
              <input type="password" matInput placeholder="Current Password" formControlName="currentPassword"
                name="currentPassword">
              <mat-error>
                <eguard-validation-messages [control]='changePasswordForm.controls.currentPassword'>
                </eguard-validation-messages>
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="">
            <mat-form-field class="example-full-width" style="width: 100%">
              <input type="password" matInput placeholder="New Password" (keyup)="onKey($event)"
                formControlName="newPassword" name="newPassword">
              <mat-error>
                <eguard-validation-messages [control]='changePasswordForm.controls.newPassword'>
                </eguard-validation-messages>
              </mat-error>
            </mat-form-field>
          </div>

          <mat-chip color="{{password.pclass}}" selected="true" *ngIf="changePasswordForm.controls.newPassword && changePasswordForm.controls['newPassword']?.touched && !changePasswordForm.controls['newPassword'].valid">
            {{password.stength}}</mat-chip>

          <div fxFlex="">
            <mat-form-field class="example-full-width" style="width: 100%">
              <input type="password" matInput placeholder="Confirm Password" formControlName="confirmPassword"
                name="confirmPassword">
              <mat-error>
                <eguard-validation-messages [control]='changePasswordForm.controls.confirmPassword'>
                </eguard-validation-messages>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>
  </div>

</div>
<div style="padding: 0 25px;">
  <div fxFlex fxLayout="row" fxLayoutAlign="end center">
    <button mat-raised-button (click)="updatePassword()" [disabled]="!changePasswordForm.valid"
      tabindex="-1">Update</button>&nbsp;&nbsp;&nbsp;
    <!-- <button mat-raised-button (click)="onNoClick()" tabindex="-1">Cancel</button> -->
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/change-password/change-password.component.html